module.exports = __webpack_public_path__ + "static/sys_ph11-ceaed7e673a058d9db4d47231ff438d9.jpg";